import React from 'react';
import { Button, Stack } from '@mui/material';

import { hasTrussAnalysisPermission, hasTrussDesignPermission, hasTrussSettingsPermission } from '@paragon/login-tools';

import { showSettingsPanel } from '../../../../store/actions/appActions';
import { getSelectedItemEntries } from '../../../../store/selectors/getSelectedItemSelector';
import { getSelectedModelForSettingsPanel } from '../../../../store/selectors/settingsPanelSelectors';
import { settingsShouldBeViewOnly } from '../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector, useIsClientInMobileMode } from '../../../hooks';

const SettingsButtons = () => {
  const dispatch = useAppDispatch();
  const mobile = useIsClientInMobileMode();

  const disabled = useAppSelector(
    (state) => getSelectedModelForSettingsPanel(state) == null || settingsShouldBeViewOnly(state),
  );
  const canSeeSettingsButtons = useAppSelector(hasTrussSettingsPermission);
  const hasAnalysisPermission = useAppSelector(hasTrussAnalysisPermission);
  const hasDesignPermission = useAppSelector(hasTrussDesignPermission);
  const selectedItemEntries = useAppSelector(getSelectedItemEntries);

  const canSeeAnyIndividualButtons = hasAnalysisPermission || hasDesignPermission;

  if (!canSeeSettingsButtons || !canSeeAnyIndividualButtons) return null;

  return (
    <Stack direction="row" spacing={1} sx={{ marginBottom: 1 }}>
      {hasAnalysisPermission && (
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={() => dispatch(showSettingsPanel('loadSettings', mobile, selectedItemEntries))}
        >
          Load Settings
        </Button>
      )}

      {hasAnalysisPermission && (
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={() => dispatch(showSettingsPanel('analysisSettings', mobile, selectedItemEntries))}
        >
          Analysis Settings
        </Button>
      )}

      {hasDesignPermission && (
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={() => dispatch(showSettingsPanel('materialSettings', mobile, selectedItemEntries))}
        >
          Material Settings
        </Button>
      )}
    </Stack>
  );
};

export default SettingsButtons;
